module.exports = __webpack_public_path__ + "img/line-stickers3.f97a1db5.svg";